import {RequestStatusEnum} from './requestStatusEnum';

export class AcoverviewModel {
  status: RequestStatusEnum;
  doctorUUID: string;
  language: string;
}
